/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useRef, useState, useEffect} from 'react'
import Calendar from 'react-calendar'
import moment from 'moment';
import { PriceHandler } from '../../../redux/helper/CamelCase'

const Value = ({orderData, handleOrderData}) => {
    const [current,setCurrent] = useState('MONTHLY');
    const [customDate,setCustomDate] = useState(false);
    const toggleState = {
        start_date: false,
        end_date: false,
        order_start_date: false,
        order_end_start:false,
    };
    const [toggle, settoggle] = useState(toggleState);
    const [dateselected, setdateselected] = useState({
        start_date: '',
        end_date: '',
    });
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleFetch = async() => {
        const date_range = `${moment(dateselected.start_date).format('DD-MM-YYYY')},${moment(dateselected.end_date).format('DD-MM-YYYY')}`
        await handleOrderData('',date_range)
        setCurrent('CUSTOM')
        setCustomDate(false)
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setdateselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state)
        setdateselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };
    let profileRef = useRef();

    useEffect(() => {
        let handler = (event) => {
            if(profileRef && !profileRef.current.contains(event.target)) {
                // setCurrent('MONTHLY')
                setCustomDate(false)         
            }   
        }
        document.addEventListener('mousedown', handler)

        return () => {
            document.removeEventListener('mousedown', handler)
        }
    },[])
    
    return (
        <div className="lg:w-[25%] md:w-[47%] lg:mr-0 md:mr-5 lg:mt-0 mt-5 w-full bg-[#F5F5FA] pt-[15px] lg:ml-5 ml-0 pb-5 xl:px-5 sm:px-4 px-3 rounded-lg">
            <div className="flex justify-between flex-wrap items-baseline rounded-lg">
                <p className="text-black text-sm55  font-semibold">
                    <a href="#">
                        Value
                    </a>
                </p>
                <ul className="nav nav-pills nav-items-content relative  mt-3 flex  bg-[white] h-[38px] justify-center items-center rounded-[10px]  flex-row flex-wrap list-none px-1 " id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation" onClick={()=> {setCurrent('MONTHLY'); setdateselected({
                        start_date: '',
                        end_date: '',
                    })}}>
                        <a href="#pills-home" style={ current == 'MONTHLY' ? { backgroundColor: '#F5F5FA' }: {}} className="block font-semibold text-sm47 rounded dashboard xl:px-3 px-1 py-[1px] my-[1px] focus:outline-none focus:ring-0 active " id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home"
                            aria-selected="true">MTD</a>
                    </li>
                    <li className="nav-item" role="presentation" onClick={()=> {setCurrent('QUERTERLLY'); setdateselected({
                        start_date: '',
                        end_date: '',
                    })}}>
                        <a href="#pills-profile" style={ current == 'QUERTERLLY' ? { backgroundColor: '#F5F5FA' }: {}} className=" block font-semibold text-sm47 rounded dashboard xl:px-3 px-1 py-[1px] my-[1px] focus:outline-none focus:ring-0" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab"
                            aria-controls="pills-profile" aria-selected="false">QTD</a>
                    </li>
         
                    <li className="nav-item" role="presentation" onClick={()=> {setCurrent('YEARLY'); setdateselected({
                        start_date: '',
                        end_date: '',
                    })}}>
                        <a href="#pills-contact" style={ current == 'YEARLY' ? { backgroundColor: '#F5F5FA' }:{}} className="block font-semibold text-sm47 rounded dashboard xl:px-3 px-1 py-[1px] my-[1px] focus:outline-none focus:ring-0 " id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" role="tab"
                            aria-controls="pills-contact" aria-selected="false">YTD</a>
                    </li>
                    <li className="nav-item" role="presentation" onClick={()=> setCustomDate(!customDate)}>
                        <a href="#pills-contact" style={ current == 'CUSTOM' ? { backgroundColor: '#F5F5FA' }: {}} className=" block relative dashboard custom-range-field font-semibold text-sm47 rounded xl:px-3 px-1 py-[1px] my-[1px]
                  focus:outline-none focus:ring-0 " id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" role="tab"aria-controls="pills-contact" aria-selected="false">Custom</a>
                   
                    </li>
                    <div ref={profileRef} className={`custom-range2 top-10 right-0 shadow-s7 lg:w-[517px] sm:w-[350px] w-[300px] rounded-[10px]  z-20 absolute ${customDate === false? 'hidden': ''}`}>
                        <div className="bg-white  h-auto rounded-lg p-5">
                            <div className="flex justify-between ">
                                <p className="text-sm63 font-semibold text-[#555259]">Custom Date Range</p>
                                <img 
                                    src="/images/close-icon.svg" 
                                    alt="crossicon" 
                                    className="cursor-pointer close-icon w-[14px] h-[14px]"
                                    onClick={() => {setCurrent('MONTHLY'); setCustomDate(false); setdateselected({
                                        start_date: '',
                                        end_date: '',
                                    })}}
                                />
                            </div>
                            <div className="flex sm:flex-row flex-col items-center mt-3 -mx-1">
                                <div className="relative sm:w-1/2 w-full px-1 mb-2"
                                    onClick={() => handleToggle('start_date')}
                                >
                                    <label></label>
                                    <img 
                                        onClick={() => handleToggle('start_date')}
                                        src="images/Iconawesome-calendar-alt.svg" 
                                        alt="icon" 
                                        className="absolute top-3 right-2.5 cursor-pointer"/>
                                    <input 
                                        datepicker 
                                        datepicker-autohide 
                                        type="text" 
                                        value={dateselected.start_date === '' ? '' : moment(dateselected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                            .join('/')}
                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs6 placeholder:font-normal placeholder:text-[#808285]" 
                                        placeholder="From Date" />
                                </div>
                                {toggle.start_date && (
                                    <Calendar
                                        maxDate={new Date()}
                                        value={moment(dateselected.start_date).format('YYYY/MM/DD').start_date}
                                        onChange={(val) => handleDate(val, 'start_date')}
                                        placeholder="Date from"
                                    />
                                )}
                                <p className="text-base font-normal text-[#555259] px-2.5 pb-50">to</p>
                                <div className="relative sm:w-1/2 w-full px-1 mb-2"
                                    onClick={() => handleToggle('end_date')}
                                >
                                    <img 
                                        onClick={() => handleToggle('end_date')}
                                        src="/images/Iconawesome-calendar-alt.svg" 
                                        alt="icon" 
                                        className="absolute top-3 right-2.5 cursor-pointer"/>
                                    <input 
                                        datepicker 
                                        datepicker-autohide 
                                        type="text" 
                                        value={dateselected.end_date === '' ? '' : moment(dateselected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                            .join('/')}
                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs6 placeholder:font-normal placeholder:text-[#808285]" 
                                        placeholder="To Date" 
                                    />
                                </div>
                                {toggle.end_date && dateselected.start_date !== '' && (
                                    <Calendar
                                        value={moment(dateselected.end_date).format('YYYY/MM/DD').end_date}
                                        onChange={(val) => handleDate(val, 'end_date')}
                                        placeholder="Date to"
                                        minDate={moment(dateselected.start_date).toDate()}
                                        maxDate={new Date()}
                                    />
                                )}
                            </div>
                            <div className="flex justify-center close-icon pt-[10px]">
                                <button className="text-sm62 w-[207px] h-[40px] font-normal ml-5 mr-[10px]  text-center text-white bg-[#555259] rounded-lg px-[20px] py-[4px]" onClick={handleFetch}>Apply</button>
                            </div>
                        </div>


                    </div>
            
                </ul>
       
            </div>  
            {/* <!--order values  --> */}
            <div className="grid lg:grid-cols-1 sm:grid-cols-1 grid-cols-1 lg:gap-7 pt-4 md:gap-5 gap-4">
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Total Order Value</p>
                        <p className=" sm:text-sm58 font-normal text-black pb-[20px]">{orderData.length>1 && PriceHandler(orderData[0][`${current}_VALUE`])}</p>
        
                    </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Total Billing Value</p>
                        <p className=" sm:text-sm58 font-normal text-black pb-[20px]">{orderData.length>1 && PriceHandler(orderData[0][`${current}_BILLING_VALUE`])}</p>
          
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Value
